type WhenCallback<T> = (builder: ArrayBuilderUtil<T>) => void;
type WhenParameter<T> = WhenCallback<T> | T | T[];
type Booleanish = boolean | string | number | null | undefined;

const isWhenCallback = <T>(
  callback: WhenParameter<T>
): callback is WhenCallback<T> => {
  return typeof callback === 'function';
};

class ArrayBuilderUtil<T> {
  private array: T[] = [];

  constructor(initial?: T[]) {
    if (initial) {
      this.array = initial;
    }
  }

  public when(
    condition: Booleanish,
    callback: WhenCallback<T>,
    elseCallback?: WhenCallback<T>
  ): ArrayBuilderUtil<T>;
  public when(
    condition: Booleanish,
    value: T | T[],
    elseValue?: T | T[]
  ): ArrayBuilderUtil<T>;
  public when(
    condition: Booleanish,
    whenTrue: WhenParameter<T>,
    whenFalse?: WhenParameter<T>
  ): ArrayBuilderUtil<T> {
    const applyParam = (param: WhenParameter<T>) => {
      if (isWhenCallback(param)) {
        param(this);
      } else {
        this.add(param);
      }
    };

    if (condition) {
      applyParam(whenTrue);
    } else {
      if (whenFalse) {
        applyParam(whenFalse);
      }
    }

    return this;
  }

  public add(item: T | T[]): ArrayBuilderUtil<T> {
    if (Array.isArray(item)) {
      this.array.push(...item);
    } else {
      this.array.push(item);
    }

    return this;
  }

  public build(): T[] {
    return this.array;
  }
}

export function arrayBuilder<T = any>(initial?: T[]): ArrayBuilderUtil<T> {
  return new ArrayBuilderUtil<T>(initial);
}
